/**
 * telegram-user service
 */

import {factories} from '@strapi/strapi';
import type {User} from "@telegraf/types/manage";
import {TelegramBotServiceType} from "./telegram-bot";
const UID = 'plugin::telegram-bot.telegram-user';
const BOT_ID = 'plugin::telegram-bot.telegram-bot';

const TelegramUser = factories.createCoreService(UID, ({strapi}) => ({
  wallet: strapi.plugin('blockchain').service('walletService'),
  telegramBot: strapi.plugin('telegram-bot').service<TelegramBotServiceType>('telegram-bot'),
  // Issue-80 | Setup config enable/disable auto create evm wallet
  isEnableCreateWallet:strapi.plugin('blockchain').config<boolean>('user.autoCreateWallet'),

  async upsertUser(userInfo: User, botInfo: User) {
    // Todo: Linking with telegram group
    // Get existed user
    const userExisted = await strapi.documents(UID).findMany({
      limit: 1,
      filters: {
        telegram_id: {
          $eq: userInfo.id,
        },
      },
      populate: ['bot_list'],
    });

    const existed = userExisted[0];
    if (existed) {
      strapi.log.info(`User with telegramId ${userInfo.id} is already registered`);

      // Check bot existed?
      const botExisted = await existed.bot_list.some(bot => bot.username === botInfo?.username);
      if (botExisted) {
        strapi.log.info(`User with telegramId ${userInfo.id} is already registered this bot`);
      } else {
        let listNewBot = existed.bot_list.map(botId => botId.id);
        const botGetUsername = await this.telegramBot.getBotByUsername(botInfo?.username);
        if (botGetUsername?.id) {
          listNewBot.push(botGetUsername?.id);
        }
        let documentId: string = existed.documentId;
        await strapi.documents(UID).update({
          ...listNewBot,
          documentId,
              data: {
                bot_list: listNewBot
              }
        })
      }
      return existed;
    } else {
      // Issue-80 | check status feature create wallet
      let wallet = null;
      if(this.isEnableCreateWallet) {
        wallet = await this.wallet.generateNew(`${userInfo.id} | ${userInfo.username || ''}`);
      }
      const botGetUsername = await this.telegramBot.getBotByUsername(botInfo?.username);
      // Todo: Get user photo
      // Todo: Link telegram user with their groups
      const user = await strapi.documents(UID).create({
        populate: wallet ? ['evm_wallet','bot_list'] : ['bot_list'],
        data: {
          telegram_id: userInfo.id,
          telegram_username: userInfo.username,
          first_name: userInfo.first_name,
          last_name: userInfo.last_name,
          is_bot: userInfo.is_bot,
          language_code: userInfo.language_code,
          evm_wallet: wallet ? wallet.id : null,
          bot_list: botGetUsername?.id ? [botGetUsername?.id] : []
        }
      })

      strapi.log.info(`New user with telegramId ${userInfo.id} has been created`);
      return user;
    }
  },
  async getUserByTelegramId(telegramId: number | string) {
    if (!telegramId) return null;
    if (typeof telegramId === 'string') telegramId = parseInt(telegramId, 10);
    // Todo: Should cache users and auto clean up if needed
    const users = await strapi.documents(UID).findMany({
      filters: {
        telegram_id: {
          $eq: telegramId,
        },
      },
      populate: ['evm_wallet']
    });

    return users[0];
  },
  async findUserByTelegramId(telegramId: number | string) {
    return await strapi.db.query(UID).findOne({
      where: {
        telegram_id: {
          $eq: telegramId,
        },
      }
    })
  }
}));

export type TelegramUserServiceType = typeof TelegramUser;

export default TelegramUser;
